import { handleErrorApi } from "../../helpers/randoms";
import TurnosService from "../../services/TurnosService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const limpiarAbmUsuarioPorIdProfesional = () =>
    async (dispatch) => {
        dispatch({ type: types.abmUsuarioPorIdProfesionalLimpiar });
}

export const getAbmUsuarioPorIdProfesional = (idProfesional) => 
async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await TurnosService.getAbmUsuarioPorIdProfesional(idProfesional);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.abmUsuarioPorIdProfesionalSuccess,
                payload: body,
            });
        } else {
            throw body;
        }
        dispatch(finishSpinner());
    } catch (error) {
        dispatch({ type: types.abmUsuarioPorIdProfesionalError });
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al traer Usuario por Id Profesional",
            "Ha ocurrido un error. Intente nuevamente"
        );
    };
};

export const putAbmUsuarioPorIdProfesional = (
    idEfectorP,
    idCentroMedico,
    idEspecialidad,
    nroMedicoOspe,
    descripcion,
    userName,
    centroMedico,
    setActualizarUsuario,
) => { 
    return async (dispatch) => {
        try{
            dispatch(startSpinner());
            const data = {
                centroMedico,
                especialidad: descripcion,
                idCentroMedico,
                idEfector: idEfectorP,
                idEspecialidad,
                nroMedicoOspe,
                userName,
            }
            const response = await TurnosService.putAbmUsuarioPorIdProfesional({idEfectorP, idCentroMedico, idEspecialidad, nroMedicoOspe});
            const body = await response.json();
            if (response.ok) {
                dispatch({
                    type: types.abmSetUsuarioPorIdProfesional,
                    payload: data,
                })
                setActualizarUsuario&& setActualizarUsuario(data);
            } else {
                throw body
            }
            dispatch(finishSpinner());
            dispatch(startAlerta(`Usuario de Ospe Modificado`,'success','Comando Exitoso'));
        } catch (error){
            dispatch({ type: types.abmUsuarioPorIdProfesionalError });
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al traer Usuario por Id Profesional",
                "Ha ocurrido un error. Intente nuevamente"
            );
        }
        };
  };

  export const updateUsuarioOspeTurb001 = (idProfesional) => {
    return async (dispatch) => {
        try{            
            dispatch(startSpinner());
            const response = await TurnosService.updateUsuarioOspeTurb001({idProfesional});
            const body = await response.json();
            if (!response.ok)
                throw body
            dispatch(startAlerta(`Usuario de Ospe Actualizado en Turb 001`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } catch (error){
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al actualizar Usuario de Ospe en Turb 001",
                "Ha ocurrido un error. Intente nuevamente"
            );
        }
    };
  };
